var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAurumCenterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "none",
    stroke: "#b8860b",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 62,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 36,
    fontWeight: 600,
    fill: "#b8860b"
  }, "A")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurumCenterLogo);
export default __webpack_public_path__ + "static/media/aurum_center_logo.7955149934c9a488eac65d6b1f6c461b.svg";
export { ForwardRef as ReactComponent };